module.exports = __webpack_public_path__ + "media/Loops Bass.2c824507.wav";